import Cookies from 'js-cookie'
import apiClient from '../../services/apiClient'
import { SET_LOADER, LOGIN_SUCCESS, LOGIN_FAIL } from '../types/authTypes'
import { toastAlert } from '../../helpers/toastAlert'
import { fetchRolePermissions } from './RoleActions'

// Login user
export const loginUser = (email, password, redirect) => async (dispatch) => {
  dispatch({
    type: SET_LOADER,
    payload: true,
  })

  try {
    const body = { email, password }

    const response = await apiClient.post('/auth/signin', body)

    const loginResponse = response?.data?.data

    if (!loginResponse?.token) {
      throw new Error(response?.data?.message || 'Authentication problem')
    }
    try {
      await fetchRolePermissions(loginResponse.token, loginResponse.role, loginResponse.operations)
    } catch (permissionError) {
      console.log('Permission load error:', permissionError)
      Cookies.set('Permissons', JSON.stringify(loginResponse.operations || []))
    }
    dispatch({
      type: LOGIN_SUCCESS,
      payload: response.data,
    })
    Cookies.set('ClaccessToken', loginResponse.token)
    Cookies.set('ClidToken', loginResponse._id)
    Cookies.set('Clemail', loginResponse.email)
    Cookies.set('ClfirstName', loginResponse.name)
    Cookies.set('Clrole', loginResponse.role)
    Cookies.set('ClisAuthenticated', true)
    Cookies.set('EmployeeId', (loginResponse?.employee?._id || null))
    // Set after an admin password reset: PrivateRoute keeps the user on the
    // profile page until they choose their own password.
    if (loginResponse?.mustChangePassword) {
      Cookies.set('ClmustChangePassword', 'true')
    } else {
      Cookies.remove('ClmustChangePassword')
    }
    toastAlert('Login Successfully.', 'success')
    dispatch({
      type: SET_LOADER,
      payload: false,
    })
    
    redirect()
  } catch (err) {
    console.log('Login Error:', err)

    const errorMessage =
      err.response?.data?.message || err.message || 'Login failed'

    toastAlert(errorMessage, 'error')

    dispatch({
      type: SET_LOADER,
      payload: false,
    })

    dispatch({
      type: LOGIN_FAIL,
    })
  }
}
